import moment from 'moment';
import { DataSetsConfig } from './constants';

type RawData = {
  date: string[];
};

const createGradient = (
  canvas: HTMLCanvasElement,
  baseColor: string,
): CanvasGradient | string => {
  const ctx = canvas.getContext('2d');
  if (ctx === null) return 'white';

  const gradient = ctx.createLinearGradient(300, 0, 300, 600);
  gradient.addColorStop(0, baseColor);
  gradient.addColorStop(1, 'transparent');
  return gradient;
};

export const getMappedData = (canvas: HTMLCanvasElement, rawData: RawData) => {
  const datasets = Object.entries(rawData)
    .filter(entry => Object.keys(DataSetsConfig).includes(entry[0]))
    .map(entry => {
      const [key, value] = entry;

      return {
        ...DataSetsConfig[key],
        ...{ data: value },
        backgroundColor: createGradient(canvas, DataSetsConfig[key].baseColor),
      };
    });

  return {
    labels: rawData.date.map(d => moment(d).format('ddd')),
    datasets,
  };
};
